export default "__VITE_ASSET__fEjHiJKR__"